import { Component } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  template: `
    <zenith-card zn-mobile-full-width class="m-3">
      <zenith-card-content>
        <div class="zn-row">
          <div class="zn-col-1 zn-col-sm-1 zn-col-md-2 zn-col-lg-3"></div>
          <div class="zn-text-align-center zn-col-10 zn-col-sm-10 zn-col-md-8 zn-col-lg-6">
            <img src="assets/images/404.svg" alt="404 not found" />

            <h1>
              {{ 'components.common.not-found.title' | translate }}
            </h1>
            <p>
              {{ 'components.common.not-found.message' | translate }}
            </p>

            <zenith-button
              [routerLink]="'/new'"
              zn-appearance="primary">{{ 'components.common.not-found.visit-home' | translate }}
            </zenith-button>
          </div>
          <div class="zn-col-1 zn-col-sm-1 zn-col-md-2 zn-col-lg-3"></div>
        </div>
      </zenith-card-content>
    </zenith-card>
  `,
  imports: [ZenithComponentsModule, TranslateModule, RouterLink],
  standalone: true
})
export class NotFoundComponent {}
